namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_layout_hor, {

		Includes: {
			position: 'absolute',
			left: '100px',
		},

		Widget_head: {
			pointerEvents: 'auto',
			margin: {
				top: '-40px',
			},
		},

		Top_edge: { pointerEvents: 'auto' },
		Left_edge: { pointerEvents: 'auto' },
		Bottom_edge: { pointerEvents: 'auto' },
		Right_edge: { pointerEvents: 'auto' },
		Top_left_edge: { pointerEvents: 'auto' },
		Top_right_edge: { pointerEvents: 'auto' },
		Bottom_left_edge: { pointerEvents: 'auto' },
		Bottom_right_edge: { pointerEvents: 'auto' },
		Left_top_edge_ratio: { pointerEvents: 'auto' },
		Left_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_top_edge_ratio: { pointerEvents: 'auto' },
		Top_left_edge_ratio: { pointerEvents: 'auto' },
		Top_right_edge_ratio: { pointerEvents: 'auto' },
		Bottom_left_edge_ratio: { pointerEvents: 'auto' },
		Bottom_right_edge_ratio: { pointerEvents: 'auto' },
		
		New_pos: {
			position: 'absolute',
			top: '1px',
			bottom: '1px',
			outlineOffset: '-2px',
			border: {
				radius: $mol_gap.round,
				left: {
					style: 'dashed',
					width: '2px',
					color: $mol_theme.current,
				},
			},
			backgroundColor: `color-mix(in srgb, var(--mol_theme_current) 10%, transparent);`,
		},
		
	} )
	
}
